import { createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: '捷诚电脑'
    }
  },
  // {
  //   path: "/storeInit",
  //   name: "storeInit",
  //   component: () =>
  //     import("../views/StoreOrder/StoreInit.vue"),
  //   meta: {
  //     title: '捷诚电脑'
  //   }
  // },
 
  {
    //获取失败
    path: "/storenotlocation",
    name: "storenotlocation",
    component: () =>
      import("../../src/views/StoreOrder/StoreNotLocation.vue"),
  }, {
    //超出距离
    path: "/storeoutofrange",
    name: "storeoutofrange",
    component: () =>
      import("../../src/views/StoreOrder/StoreOutOfRange.vue"),
  },
  
  
  {
    //商品首页
    path: "/my",
    name: "my",
    component: () =>
      import("../../src/views/my.vue"),
  },
  {
    //登录
    path: "/login",
    name: "login",
    component: () =>
      import("../../src/views/Accounts/Login.vue"),
  }, {
    //注册
    path: "/register",
    name: "register",
    component: () =>
      import("../../src/views/Accounts/register.vue"),
  },

  {
    //地址
    path: "/addresslist",
    name: "addresslist",
    component: () =>
      import("../../src/views/Accounts/addresslist.vue"),
  },
  {
    //地址编辑
    path: "/addressedit",
    name: "addressedit",
    component: () =>
      import("../../src/views/Accounts/addressEdit.vue"),
  },
  {
    //sysred支付
    path: "/sysred",
    name: "sysred",
    component: () =>
      import("../../src/views/Pays/SysRed.vue"),
  },
  //我的订单
  {
    path: "/myorder",
    name: "myorder",
    component: () =>
      import("../../src/views/Accounts/myorder.vue"),
  },
  //编辑用户信息
  {
    path: "/userEdit",
    name: "userEdit",
    component: () =>
      import("../../src/views/Accounts/userEdit.vue"),
  },
  //店内点餐商品
  {
    path: "/storeorder",
    name: "storeorder",
    component: () =>
      import("../views/StoreOrder/StoreCategory.vue"),
  },

  //店内点餐商品
  {
    path: "/storeCategorySidebar",
    name: "storeCategorySidebar",
    component: () =>
      import("../views/StoreOrder/StoreCategorySidebar.vue"),

  },
  
    //预览页
    {
      path: "/storePreviewAll",
      name: "storePreviewAll",
      component: () =>
        import("../views/StoreOrder/StorePreviewAll.vue"),
  
    },
  //预览页
  {
    path: "/storePreview",
    name: "storePreview",
    component: () =>
      import("../views/StoreOrder/StorePreview.vue"),

  },
  {
    path: "/storePreviewCategory",
    name: "storePreviewCategory",
    component: () =>
      import("../views/StoreOrder/StorePreviewCategory.vue"),

  },
  {
    path: "/storePreviewCollection",
    name: "storePreviewCollection",
    component: () =>
      import("../views/StoreOrder/StorePreviewCollection.vue"),

  },



  //预览详情
  {
    path: "/storePreviewDetail",
    name: "storePreviewDetail",
    component: () =>
      import("../views/StoreOrder/StorePreviewDetail.vue"),

  },

  //店内点餐购物车
  {
    path: "/storeshoppingcart",
    name: "storeshoppingcart",
    component: () =>
      import("../views/StoreOrder/StoreShoppingCart.vue"),
    meta: {
      keepAlive: false
    }
  },
  //店内点餐套餐
  {
    path: "/storeCollection",
    name: "storeCollection",
    component: () =>
      import("../views/StoreOrder/StoreCollection.vue"),
  },
  //店内点餐前台下单套餐
  {
    path: "/storeCollectionQianTai",
    name: "storeCollectionQianTai",
    component: () =>
      import("../views/StoreOrder/StoreCollectionQianTai.vue"),
  },

  //店内点餐详细页
  {
    path: "/storeCollectionItems",
    name: "storeCollectionItems",
    component: () =>
      import("../views/StoreOrder/StoreCollectionItems.vue"),
  },
  // 推荐套餐
  {
    path: "/storeRecommendCollection",
    name: "storeRecommendCollection",
    component: () =>
      import("../views/StoreOrder/StoreRecommendCollection.vue"),
  },


  
  {
    path: "/storeHome",
    name: "storeHome",
    component: () =>
      import("../views/StoreOrder/StoreHome.vue"),
  }, {
    path: "/storeCollectionFixed",
    name: "storeCollectionFixed",
    component: () =>
      import("../views/StoreOrder/StoreCollectionFixed.vue"),
  },
  //外卖首页
  {
    path: "/takeOutHome",
    name: "takeOutHome",
    component: () =>
      import("../views/TakeOuts/TakeOutHome.vue"),
  },
  //我的购物车
  {
    path: "/myShoppingCart",
    name: "myShoppingCart",
    component: () =>
      import("../views/TakeOuts/MyShoppingCart.vue"),
  },
  {
    path: "/takeOutCollection",
    name: "takeOutCollection",
    component: () =>
      import("../views/TakeOuts/TakeOutCollection.vue"),
  },

  {
    path: "/takeOutCollectionItems",
    name: "takeOutCollectionItems",
    component: () =>
      import("../views/TakeOuts/TakeOutCollectionItems.vue"),
  },



];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
export default router;
